import { useContext } from 'react';

import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import reactReplacePlaceholder from 'react-replace-placeholder';

import StringsContext from '../Contexts/StringsContext';

import type { CodeshareData } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArrivalsDepartures';

interface CodeshareProps {
  codeshares?: CodeshareData[];
}

const Codeshare = ({ codeshares = [] }: CodeshareProps) => {
  const strings = useContext(StringsContext);
  const operatorName = codeshares
    .map(
      ({ airlineId, airlineName, flightNumber }) =>
        `${airlineName} (${airlineId}${flightNumber})`,
    )
    .join(', ');

  return (
    <BpkText
      tagName="p"
      data-testid="codeshare"
      textStyle={TEXT_STYLES.xs}
      color={TEXT_COLORS.textSecondary}
    >
      {reactReplacePlaceholder(
        strings.falcon_arrivals_departures_board_codeshare_new,
        {
          operator_name: operatorName,
        },
        '{',
        '}',
      )}
    </BpkText>
  );
};

export default Codeshare;
